var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowflakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h32.121v32.35H0z"
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h135.54v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.751 20.429c.944.15 1.665.967 1.665 1.953v7.816a1.977 1.977 0 1 1-3.954 0v-4.413L6.626 28a1.986 1.986 0 0 1-1.985-3.438l6.755-3.9a1.981 1.981 0 0 1 1.355-.233Zm5.416.959a1.986 1.986 0 0 1 2.712-.726l6.755 3.9A1.984 1.984 0 1 1 25.649 28l-3.785-2.185v4.383a1.976 1.976 0 1 1-3.954 0v-7.625a1.98 1.98 0 0 1 .257-1.185ZM.42 11.273a1.985 1.985 0 0 1 2.711-.726l6.756 3.9a1.982 1.982 0 0 1 .992 1.754 1.986 1.986 0 0 1-.992 1.738l-6.756 3.9a1.984 1.984 0 1 1-1.984-3.438l3.824-2.208-3.824-2.208a1.985 1.985 0 0 1-.727-2.712Zm31.435 0c.548.95.222 2.163-.727 2.712l-3.825 2.208 3.825 2.208a1.985 1.985 0 1 1-1.985 3.438l-6.755-3.9a1.987 1.987 0 0 1-.993-1.738 1.985 1.985 0 0 1 .993-1.754l6.755-3.9a1.986 1.986 0 0 1 2.712.726Zm-15.36 1.224c.15 0 .358.086.465.193l2.679 2.679a.758.758 0 0 1 .193.465v.682c0 .15-.086.358-.193.465L16.96 19.66a.758.758 0 0 1-.465.193h-.682a.752.752 0 0 1-.465-.193l-2.68-2.679a.757.757 0 0 1-.192-.465v-.682c0-.15.086-.358.192-.465l2.68-2.679a.758.758 0 0 1 .465-.193h.682Zm-.326 2.391h-.03a.554.554 0 0 0-.341.141l-.79.79a.553.553 0 0 0-.142.341v.03c0 .11.063.263.142.341l.79.79c.078.078.23.141.341.141h.03c.11 0 .262-.063.341-.141l.79-.79a.552.552 0 0 0 .141-.341v-.03a.554.554 0 0 0-.141-.341l-.79-.79a.554.554 0 0 0-.341-.141ZM12.439.175c1.092 0 1.977.885 1.977 1.977v7.816a1.97 1.97 0 0 1-.638 1.455 1.988 1.988 0 0 1-2.382.301l-6.755-3.9a1.985 1.985 0 1 1 1.985-3.438l3.836 2.215V2.152c0-1.092.885-1.977 1.977-1.977Zm7.448 0c1.093 0 1.977.885 1.977 1.977v4.419l3.785-2.185a1.985 1.985 0 1 1 1.985 3.438l-6.755 3.9a1.985 1.985 0 0 1-2.969-1.911V2.152c0-1.092.886-1.977 1.977-1.977Z",
    style: {
      fill: "#2ab5e8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflakeIcon);
export default __webpack_public_path__ + "static/media/Snowflake_icon.0e358cc2afbc075123716c6358367039.svg";
export { ForwardRef as ReactComponent };